var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "#222831"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.724 516.274C130.491 504.055 136.888 487.673 153.612 492.154C161.559 494.283 167.734 506.129 167.249 513.662C166.846 519.909 168.581 527.8 162.133 531.69C157.069 534.746 150.668 534.312 146.674 529.582C135.333 516.149 156.29 506.737 166.683 508.792C180.867 511.597 197.304 546.937 184.949 558.098C174.356 567.668 167.387 552.982 174.786 544.272C185.194 532.019 194.768 531.63 206.872 544.735C216.322 554.968 213.48 573.028 205.855 582.529C204.271 584.503 198.344 598.315 196.913 596.93C182.79 583.266 207.81 563.134 221.713 565.996C237.687 569.285 253.813 572.795 264.371 585.439C270.049 592.238 280.529 616.563 278.515 607.936C275.995 597.141 273.576 582.327 278.05 571.575C279.382 568.376 283.386 558.057 280.005 568.073C276.523 578.389 273.216 587.394 271.799 597.637C271.484 599.916 274.446 603.15 275.457 605.083C276.313 606.721 269.649 604.617 268.853 604.534C261.977 603.82 255.693 606.468 249.802 609.759C244.544 612.697 238.526 618.21 234.561 616.25",
    stroke: "#00ADB5",
    strokeOpacity: 0.2,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.24 810.397C1218.2 806.281 1226.32 800.898 1233.43 795.394C1237.24 792.449 1241.34 789.923 1245.03 786.875C1245.54 786.445 1246.82 784.419 1247.59 785.083C1248.81 786.131 1249.99 787.95 1250.74 789.366C1252.9 793.479 1255.88 797.606 1258.94 801.069C1261.36 803.817 1263.33 806.137 1265.18 809.33C1266.18 811.076 1268.69 813.459 1268.51 815.4C1268.01 820.813 1262.95 825.826 1259.48 829.367C1254.38 834.57 1249.38 839.8 1243.32 843.799C1239.55 846.28 1235.31 847.59 1231.46 849.811C1227.92 851.857 1228.21 851.583 1224.84 848.609C1221.51 845.68 1219.45 842.502 1217.2 838.595C1216.02 836.562 1213.92 834.806 1212.29 833.125C1211.06 831.853 1210.61 829.68 1209.94 828.079C1209.24 826.399 1209.3 821.582 1207.77 820.579C1206.26 819.595 1204.52 817.434 1204.94 815.497C1205.29 813.916 1218.45 804.647 1207.46 814.994",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.05 817.941C1209.05 819.396 1211.96 821.485 1214.93 822.85C1215.91 823.304 1217.6 823.219 1218.39 823.84C1220.54 825.52 1226.76 824.5 1229.4 824.742C1232.38 825.016 1240.55 829.104 1241.64 824.079C1243.7 814.634 1246.01 805.231 1248.06 795.824C1248.44 794.047 1247.92 792.292 1248.27 790.669C1249.35 785.729 1244.61 788.846 1243.01 789.772",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M839.805 129.823C857.977 121.281 873.445 108.789 888.904 96.9114C901.054 87.5763 913.727 78.2772 926.864 69.9243C929.456 68.2761 933.233 65.1204 936.313 65.9402C939.365 66.7526 940.774 69.7371 943.052 71.3428C948.662 75.2971 953.496 80.3555 957.88 85.2497C962.705 90.6374 953.748 94.9214 947.948 99.4521C941.361 104.598 935.022 109.855 927.957 114.536C921.242 118.986 915.545 124.721 909.285 129.608C899.743 137.056 890.702 144.861 881.184 152.313C875.519 156.749 869.196 160.561 863.701 165.113C861.775 166.708 859.917 168.739 857.759 170.129C856.026 171.246 854.31 167.891 853.834 167.276C850.055 162.396 843.553 159.496 839.903 154.358C837.608 151.127 836.341 146.965 833.454 144.103C832.076 142.737 828.577 139.707 830.636 137.255C832.738 134.752 837.951 133.082 840.941 131.123C843.271 129.596 846.107 127.715 848.68 126.547C850.549 125.698 852.457 124.35 854.171 123.285C858.684 120.481 854.108 121.976 851.154 123.161",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M840.968 140.104C850.743 144.158 859.11 150.67 866.27 157.215C866.451 157.381 868.291 158.276 867.929 158.724C867.23 159.589 860.916 156.745 860.315 156.456",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M852.432 131.379C860.673 132.386 865.228 135.549 871.547 138.772C874.362 140.207 877.258 141.463 879.715 143.246C880.869 144.083 881.608 145.274 882.653 146.199C884.086 147.467 877.848 145.078 877.112 144.805",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M865.621 124.132C870.977 127.79 876.373 131.385 881.941 134.848C884.056 136.164 886.505 137.314 888.262 138.946C891.383 141.842 887.291 138.089 885.867 137.059",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M874.544 119.074C878.662 120.741 882.987 122.318 886.324 124.813C887.693 125.836 888.77 127.103 890.257 128.026C892.089 129.164 893.639 130.557 895.489 131.655C898.125 133.219 898.484 133.721 895.371 131.737",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M886.19 111.523C890.638 114.046 894.717 116.657 898.273 119.945C899.848 121.401 901.037 123.152 903.152 124.167C905.089 125.098 906.514 125.27 904.32 123.651",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M897.452 103.895C901.384 106.009 905.287 107.903 908.251 110.861C909.608 112.215 910.603 113.835 912.159 115.049C915.321 117.516 913.073 116.346 910.769 114.689",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M907.942 96.1138C913.324 100.076 917.616 104.943 923.016 108.847C926.653 111.476 921.515 107.186 920.685 106.415",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M920.353 89.4719C925.659 87.2377 931.198 84.6625 934.492 80.286C935.4 79.0791 936.504 77.9934 936.99 76.6936C937.656 74.9086 937.469 75.6632 935.711 76.9669",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M927.742 94.1607C932.182 90.7083 937.135 86.9257 940.613 82.785C942.348 80.7198 945.471 78.0862 941.173 81.2737",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M939.76 99.0088C943.871 95.3953 947.547 92.0511 951.387 88.324C952.627 87.1198 956.143 85.3438 952.029 86.6498",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M937.07 97.7167C941.275 94.6433 946.041 91.0793 949.546 87.4005C950.481 86.4192 951.243 85.3573 952.114 84.3488C953.574 82.6596 953.58 83.1741 951.671 83.5446",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M850.581 144.286C870.561 135.902 877.636 118.428 894.545 107.1C896.601 105.722 898.321 104.254 900.642 103.2C902.195 102.495 904.055 102.032 905.496 101.191C906.375 100.678 913.769 95.7301 908.795 97.9892",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M842.314 140.75C844.75 138.413 846.904 136.404 849.836 134.583C850.317 134.284 851.012 134.165 851.425 133.791C852.244 133.052 853.479 131.966 853.877 131.086C855.447 127.618 860.752 127.633 863.849 125.635C866.795 123.735 869.642 121.827 872.638 119.94C875.939 117.861 877.566 116.18 880.333 113.68C882.875 111.384 885.353 109.071 888.012 106.869C890.186 105.068 893.458 103.284 894.984 101.119C896.706 98.6759 900.659 95.6575 903.829 95.7196C904.918 95.7409 912.54 98.627 907.551 96.7946",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M858.469 146.988C873.678 139.287 883.498 125.111 894.595 113.99C898.682 109.894 904.13 106.866 908.376 102.816C910.191 101.083 913.954 99.0378 909.842 99.5245",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M863.073 150.176C876.982 142.284 886.981 129.38 897.769 118.833C902.677 114.035 907.448 109.163 912.404 104.394C914.664 102.22 918.3 100.612 913.574 103.109",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M867.264 156.317C876.271 149.038 883.783 141.432 891.453 133.321C896.117 128.389 900.31 122.963 905.616 118.398C908.66 115.779 911.133 112.834 913.945 110.104C915.078 109.004 915.926 107.776 917.085 106.681C919.697 104.215 917.812 106.393 916.041 107.77",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M868.785 158.894C873.27 155.258 879.617 151.53 882.888 147.098C884.075 145.49 887.001 141.598 888.828 140.491C891.242 139.026 892.671 136.326 894.531 134.521C896.468 132.64 898.364 130.805 900.434 128.991C902.376 127.29 903.299 124.582 905.623 123.045C908.212 121.333 909.686 118.966 911.831 117.028C913.688 115.35 917.042 113.452 919.246 112.082C920.468 111.323 921.379 110.373 922.73 109.76C925.468 108.516 923.709 109.193 921.334 109.388",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M919.86 90.7014C923.104 91.0359 927.158 91.0611 930 92.1851C931.834 92.9105 933.414 93.6682 930.074 92.3472",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M923.957 85.8247C928.586 86.2927 931.799 87.0385 935.404 88.6421C937.761 89.6906 937.404 89.3671 934.934 88.3805",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M930.37 80.6492C934.207 82.0428 937.887 83.7028 941.896 84.8413C944.255 85.5108 942.957 85.5909 941.139 85.0597",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M934.17 76.6614C938.256 77.756 942.006 78.8817 945.694 80.4212C947.376 81.1233 945.727 81.3655 944.458 80.7871",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M922.191 88.8885C925.877 85.4137 929.551 82.1008 932.957 78.5808C933.924 77.5808 939.752 71.9634 937.177 74.7927",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M924.849 93.9664C929.5 90.4829 936.159 85.7873 938.151 81.1381C938.737 79.7698 939.793 78.3497 941.198 77.2964C942.622 76.2281 944.035 75.6595 941.883 77.4322",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M921.468 94.2446C926.526 89.8296 930.749 86.7699 933.969 81.6683C934.805 80.3434 935.709 79.2217 936.933 78.1157C938.23 76.9437 940.02 75.7817 937.535 77.898",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M937.969 94.2922C939.9 95.1192 941.847 95.8679 943.884 96.5079C944.725 96.7722 943.72 96.1909 943.357 96.1189",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M942.749 88.6025C942.876 88.6828 950.262 93.3983 948.988 92.3048",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M947.885 86.0178C949.493 87.2107 954.445 90.6714 952.678 89.6229",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M935.245 96.7861C938.544 94.2147 945.711 89.0492 947.795 85.431C948.616 84.0051 951.755 81.9395 948.771 84.1075",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M935.528 97.4113C935.787 97.5622 940.81 101.871 942.363 99.3352C943.155 98.0408 944.187 96.3548 945.806 95.5089C948.647 94.0248 949.66 90.2392 952.539 88.9319C955.805 87.4487 955.78 85.5776 952.98 85.2265C951.879 85.0886 953.027 83.1859 951.827 83.4598C950.728 83.7105 950.2 83.4536 948.966 83.7672",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M919.576 90.0765C921.116 92.8683 921.334 93.9186 924.321 94.8204C925.127 95.0638 926.306 94.469 926.917 94.6609C928.125 95.0406 930.656 94.7679 931.745 93.7112C933.934 91.5864 934.813 90.2748 937.922 88.7833C939.883 87.8424 941.618 85.9461 942.678 84.4166C943.843 82.7357 945.711 81.3581 946.929 79.6652C947.448 78.9444 944.259 77.5945 944.39 76.4332C944.427 76.1039 940.355 76.5502 939.716 76.3493C938.941 76.106 938.631 75.6756 938.334 75.0218C937.9 74.067 936.703 75.4469 935.143 75.7167",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M846.409 135.874C850.84 136.77 854.621 138.142 858.507 139.694C861.88 141.042 865.838 141.518 869.196 142.814C871.586 143.737 873.857 146.201 875.493 147.803C876.038 148.337 876.429 148.849 876.781 149.48C877.587 150.928 877.048 147.27 876.997 146.868",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M895.052 102.471C896.184 103.411 900.547 108.812 900.148 104.429",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPage);
export default __webpack_public_path__ + "static/media/contact-page.8fe9450aa59d1a30896545766f6665d0.svg";
export { ForwardRef as ReactComponent };